import { SortDescriptor } from "react-aria-components";

import { MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID } from "./constants";
import { ModuleVersionModuleDependencyRow, ModuleVersionProviderDependencyRow } from "./types";

const compare = (a: string, b: string, direction: number) =>
  a.localeCompare(b, undefined, { numeric: true }) * direction;

const toDirection = (sortDescriptor: SortDescriptor) =>
  sortDescriptor.direction === "ascending" ? 1 : -1;

export const sortModuleDependencies = (
  dependencies: ModuleVersionModuleDependencyRow[],
  sortDescriptor: SortDescriptor
) => {
  if (!sortDescriptor.column) {
    return dependencies;
  }

  const direction = toDirection(sortDescriptor);

  return [...dependencies].sort((a, b) => compare(a.id, b.id, direction));
};

export const sortProviderDependencies = (
  dependencies: ModuleVersionProviderDependencyRow[],
  sortDescriptor: SortDescriptor
) => {
  const direction = toDirection(sortDescriptor);

  switch (sortDescriptor.column) {
    case MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.NAME:
      return [...dependencies].sort((a, b) => compare(a.id, b.id, direction));
    case MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.VERSION:
      return [...dependencies].sort((a, b) => compare(a.version, b.version, direction));
    case MODULE_VERSION_PROVIDER_DEPENDENCIES_COLUMN_ID.SOURCE:
      return [...dependencies].sort((a, b) => compare(a.source, b.source, direction));
    default:
      return dependencies;
  }
};
